// Zero-padded "HH:mm" strings order lexically, so slot filtering and the exclusive min bound use
// the same string compare as the form's `to > from` validation.
const SLOT_MINUTES = 15;
const SLOTS_PER_DAY = (24 * 60) / SLOT_MINUTES;

const pad = (value: number): string => String(value).padStart(2, "0");

/** All 96 quarter-hour slots of the day as zero-padded "HH:mm", ascending. */
export const TIME_SLOTS: string[] = Array.from({ length: SLOTS_PER_DAY }, (_, i) => {
  const minutes = i * SLOT_MINUTES;
  return `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;
});

/**
 * Validate a free-typed hours/minutes pair into a zero-padded `"HH:mm"`, or `null` if either field
 * is empty, non-numeric, or out of range (hours 0–23, minutes 0–59).
 */
export function parseCustomTime(hours: string, minutes: string): string | null {
  if (!/^\d{1,2}$/.test(hours) || !/^\d{1,2}$/.test(minutes)) return null;
  const h = Number(hours);
  const m = Number(minutes);
  if (h > 23 || m > 59) return null;
  return `${pad(h)}:${pad(m)}`;
}
